import React, { Component } from 'react'
import { Icon, Input, Spin, Modal, Button, notification } from "antd"
import PopupConfirm from "./PopupConfirm"
import PopupReceivedSewing from "./PopupReceivedSewing"
import {
    getInformationBatchByName,
    updateStatusBatch, updateBatchReceiveSewName,
    markBatchSewed, getInformationBatchByNameV2,
    updateStatusBatchV2, callActionApi
} from "../../../services/api/3dApi"
import AdditionalModal from './AdditionalModal'

class UpdateBatchesPage extends Component {
    state = {
        getLoading: false,
        updateLoading: false,
        message: '',
        showModal: '',
        visible: false,
        disable: true,
        batch: {},
        nextStatus: '',
        scanValue: '',
        cacheValue: '',
        valueInput: '',
        errorInput: '',
        partnerSewingId: '',
        giveSewName: '',
        receiveSewName: '',
        material_weight: '',
        nextStage: '',
        inform: '',
        additionalPayLoad: {},
    }

    _input = React.createRef()

    _resetScanInput = () => {
        this.setState({
            message: '',
            disable: true,
            batch: {},
            scanValue: '',
            valueInput: '',
            partnerSewingId: '',
            giveSewName: '',
            receiveSewName: '',
            material_weight: '',
            nextStage: '',
            inform: '',
            additionalPayLoad: {},
        }, () => {
            this._input.current.focus()
        })
    }

    _handleChangeSelect = (value) => {
        this.setState({
            partnerSewingId: value
        })
    }

    _handleChangeInput = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    _onChangeAdditional = (field, value) => {
        const { additionalPayLoad } = { ...this.state }
        this.setState({
            additionalPayLoad: {
                ...additionalPayLoad,
                [field]: value
            }
        })
    }

    _handleChangeScan = (e) => {
        let { value } = e.target

        this.setState({
            message: '',
            errorInput: '',
            valueInput: value
        })
    }

    _onSubmit = (e) => {
        e.preventDefault()

        const { valueInput } = this.state
        const check = /^\w+-\d/.test(valueInput)

        this.setState({
            message: '',
            disable: true,
            batch: {},
            errorInput: !check ? 'Mã lô sai định dạng.' : ''
        }, () => {
            const valueFormatted = valueInput.trim()

            if (!valueFormatted) {
                return this.setState({
                    errorInput: 'Mã lô sai định dạng.'
                })
            }

            check && this._getBatchDetailByName(valueFormatted.toUpperCase())
        })
    }

    _getBatchDetailByName = async (value) => {
        this.setState({
            getLoading: true,
            message: '',
            scanValue: ''
        })

        try {
            const { data: response } = await getInformationBatchByNameV2({ name: value })
            const { success, data, error } = { ...response }

            if (!success) {
                return this.setState({
                    getLoading: false,
                    message: error,
                    scanValue: ''
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        okText: 'Đóng'
                    })
                })
            }

            const { disable, message, batch, nextStatus, nextStage, inform } = data
            const { additional = [] } = { ...nextStage }
            const additionalPayLoad = additional.length > 0 && additional.reduce((acc, item) => {
                acc[item.key] = '';
                return acc;
            }, {});

            if (message !== '' && disable) {
                Modal.error({
                    title: 'Lỗi',
                    content: data.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng'
                })
            }

            this.setState({
                getLoading: false,
                message: message,
                disable: disable,
                batch: batch,
                nextStatus: nextStatus,
                nextStage: nextStage,
                inform: inform,
                additionalPayLoad: additionalPayLoad,
                scanValue: ''
            }, () => {
                const { status } = batch
                const haveReceiveSewName = batch.hasOwnProperty('receive_sew_name')

                if (additional.length > 0) {
                    this._showModal('additional')
                }

                if (nextStatus === '' && status === 'sewing' && (!haveReceiveSewName || batch.receive_sew_name === '')) {
                    this._showModal('receiveSewName')
                } else if (nextStatus === '' && status === 'sewing' && haveReceiveSewName && batch.receive_sew_name !== '') {
                    Modal.error({
                        title: 'Lỗi',
                        content: 'Lô đã nhận may. Không được phép cập nhật trạng thái lô!',
                        onOk: this._resetScanInput(),
                        okText: 'Đóng'
                    })
                }
            })
        } catch (e) {
            this.setState({
                getLoading: false
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _additionalAction = async (api, batchId) => {
        const { url } = { ...api }
        const apiUrl = url.replace(/:[a-zA-Z0-9_]+/, batchId);
        const newApi = { ...api, url: apiUrl }
        try {
            const { data: response } = await callActionApi(newApi)
            const { data, success, error } = response
            if (!success) {
                throw new Error(error)
            }

            const { receive_sew_name, name } = data
            if (apiUrl.includes('/update-receive-sew-name')) {
                notification.success({
                    message: `Lô ${name} đã được cập nhật người nhận may là: ${receive_sew_name}.`,
                })
            } else if (apiUrl.includes('/mark-sewed')) {
                notification.success({
                    message: `Lô ${name} đã được đánh dấu may xong thành công.`,
                })
            } else {
                notification.success({
                    message: `Cập nhật thành công.`,
                })
            }

        } catch (e) {
            throw new Error(e.message)
        }
    }

    _updateStatus = async () => {
        this.setState({
            updateLoading: true
        })

        try {
            const { _id } = this.state.batch
            const { nextStatus, partnerSewingId, giveSewName, material_weight, additionalPayLoad, batch, nextStage } = this.state
            const { batch_state: nextBatchState, api: nextStageApi } = { ...nextStage }
            const { key: nextBatchStatus } = { ...nextBatchState }
            const { mode, meta, url } = { ...nextStageApi }
            const payload = {
                partner: partnerSewingId,
                batchIds: [_id],
                // status: nextStatus,
                give_sew_name: giveSewName.trim(),
                ...additionalPayLoad,
            }
            if (material_weight !== '') payload.material_weight = parseFloat(material_weight)

            if (mode === 'before') {
                try {
                    await this._additionalAction(nextStageApi, _id)
                } catch (error) {
                    throw new Error(error.message)
                }
            }
            try {
                const { data: response } = await updateStatusBatchV2(_id, payload)
                const { data, success, error } = { ...response }

                if (!success) {
                    throw new Error(error)
                }

                const { message, batchUpdate } = data

                this.setState({
                    updateLoading: false,
                }, async () => {
                    this._hiddenModal()
                    notification.success({
                        message: `Lô ${batch.basename} đã được cập nhật trạng thái ${nextBatchStatus}.`,
                        description: message,
                    })
                    this._resetScanInput()
                })

            } catch (error) {
                this._hiddenModal()
                throw new Error(error.message)
            }

            if (mode === 'after') {
                try {
                    await this._additionalAction(nextStageApi, _id)
                } catch (error) {
                    throw new Error(error.message)
                }
            }
        } catch (e) {
            this.setState({
                updateLoading: false,
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    // _updateReceiveSewName = async () => {
    //     this.setState({
    //         updateLoading: true
    //     })

    //     try {
    //         const { _id } = this.state.batch
    //         const { receiveSewName } = this.state
    //         const payload = {
    //             receive_sew_name: receiveSewName.trim()
    //         }

    //         const { data: response } = await updateBatchReceiveSewName(_id, payload)
    //         const { data, success, error } = response

    //         if (!success) {
    //             return this.setState({
    //                 updateLoading: false,
    //                 scanValue: ''
    //             }, () => {
    //                 this._hiddenModal()
    //                 Modal.error({
    //                     title: 'Lỗi',
    //                     content: error,
    //                     okText: 'Đóng'
    //                 })
    //             })
    //         }

    //         const { receive_sew_name, name } = data

    //         this.setState({
    //             updateLoading: false,
    //         }, () => {
    //             this._hiddenModal()
    //             this._resetScanInput()

    //             notification.success({
    //                 message: `Lô ${name} đã được cập nhật người nhận may là: ${receive_sew_name}.`,
    //             })
    //         })
    //     } catch (e) {
    //         this.setState({
    //             updateLoading: false,
    //         }, () => {
    //             this._hiddenModal()
    //             Modal.error({
    //                 title: 'Lỗi',
    //                 content: e.message,
    //                 okText: 'Đóng'
    //             })
    //         })
    //     } finally {
    //         this._resetScanInput()
    //     }
    // }

    _showModal = (type) => {
        document.body.classList.add('CustomPopup')

        this.setState({
            showModal: type,
            visible: true
        })
    }

    _hiddenModal = () => {
        document.body.classList.remove('CustomPopup')

        this.setState({
            showModal: '',
            visible: false
        })
    }

    // _markBatchSewed = async () => {
    //     this.setState({
    //         getLoading: true,
    //         message: '',
    //         scanValue: ''
    //     })

    //     try {
    //         const { _id } = this.state.batch
    //         const { data: response } = await markBatchSewed(_id)
    //         const { data, success, error } = response

    //         if (!success) {
    //             return this.setState({
    //                 getLoading: false,
    //                 scanValue: ''
    //             }, () => {
    //                 Modal.error({
    //                     title: 'Lỗi',
    //                     content: error,
    //                     okText: 'Đóng'
    //                 })
    //             })
    //         }
    //         const { name } = data
    //         this.setState({
    //             getLoading: false,
    //         }, () => {
    //             this._resetScanInput()
    //             notification.success({
    //                 message: `Lô ${name} đã được đánh dấu may xong thành công.`,
    //             })
    //         })

    //     } catch (e) {
    //         this.setState({
    //             getLoading: false,
    //         }, () => {
    //             Modal.error({
    //                 title: 'Lỗi',
    //                 content: e.message,
    //                 okText: 'Đóng'
    //             })
    //         })
    //     } finally {
    //         this._resetScanInput()
    //     }
    // }

    render() {
        const {
            getLoading,
            updateLoading,
            message,
            showModal,
            visible,
            disable,
            batch,
            nextStatus,
            valueInput,
            errorInput,
            partnerSewingId,
            giveSewName,
            material_weight,
            receiveSewName,
            nextStage,
            inform,
            additionalPayLoad,
        } = this.state

        const { status, production_meta = {} } = batch
        const { name: nextStageName, additional = [], batch_item_state } = { ...nextStage }
        const { key: nextBatchItemStageName } = { ...batch_item_state }
        const { total_items, available_items_number } = { ...inform }

        return (
            <div className="UpdateBatchesPage">
                <div className="position-relative">
                    <Spin spinning={getLoading} tip='Đang kiểm tra...'>
                        <form onSubmit={this._onSubmit} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={this._input}
                                autoFocus={true}
                                placeholder='Nhập vào tên lô'
                                onChange={this._handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={this._resetScanInput}
                                />
                            }

                            {
                                getLoading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }

                            {
                                (!getLoading && !disable && !!nextStageName) &&
                                <Button
                                    type='primary'
                                    className='float-right mt-5'
                                    onClick={() => this._showModal('additional')}
                                >
                                    {nextStageName}
                                </Button>
                            }

                            {/* {
                                (!getLoading && status === "sewing" && !production_meta.sewed) &&
                                <Button
                                    type='primary'
                                    className='float-right mt-5'
                                    onClick={() => this._markBatchSewed()}
                                    style={{ fontSize: 20 }}
                                >
                                    Đánh dấu lô may xong
                                </Button>
                            } */}
                        </form>
                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                    </Spin>

                    {
                        showModal === 'additional' &&
                        <AdditionalModal
                            visible={visible}
                            loading={updateLoading}
                            status={nextBatchItemStageName}
                            message={nextStageName}
                            total={total_items}
                            item={available_items_number}
                            batch={batch}
                            additional={additional}
                            additionalPayLoad={additionalPayLoad}
                            onUpdate={this._updateStatus}
                            onClose={this._hiddenModal}
                            onChangeAdditional={this._onChangeAdditional}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default UpdateBatchesPage
